module.exports = __webpack_public_path__ + "static/media/pw-rating-active-icon.e080ce2c.svg";